
define('inlineSvg!svgs/icon/plus', function () {return '<span class="inline-plus inline-icon"><svg width="24" height="24" viewBox="-0.5 0.5 24 24"><path d="M10.682 3.5h1.636l.41 7.773 7.772.408v1.638l-7.77.41-.413 7.772H10.68l-.407-7.77-7.773-.412V11.68l7.773-.407.41-7.773z"/></svg></span>';});

